var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchEngineResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 426,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h532v426H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search-engine-results_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-780-4409H660V5861H-780z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FB",
    d: "M-780 1351H660v-2711H-780z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#search-engine-results_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -291,
    width: 580,
    height: 739,
    rx: 16,
    fill: "url(#search-engine-results_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -291,
    width: 580,
    height: 739,
    rx: 16,
    stroke: "#EEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "search-engine-results_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 530,
    height: 390
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 389.197,
    rx: 14,
    fill: "#525376"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 529,
    height: 388.197,
    rx: 13.5,
    stroke: "#525376",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#search-engine-results_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#search-engine-results_svg__filter1_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36.803,
    width: 573,
    height: 322.03,
    rx: 16,
    fill: "url(#search-engine-results_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36.803,
    width: 573,
    height: 322.03,
    rx: 16,
    stroke: "#EEE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.577,
    cy: 52.056,
    rx: 3.577,
    ry: 3.291,
    fill: "#ED6A5D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.499,
    cy: 52.056,
    rx: 3.577,
    ry: 3.291,
    fill: "#F4BF4F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.425,
    cy: 52.056,
    rx: 3.577,
    ry: 3.291,
    fill: "#62C755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1 91.04c0 2.25-1.913 3.908-4.261 3.908-2.349 0-4.262-1.658-4.262-3.909 0-2.266 1.913-3.908 4.262-3.908 2.348 0 4.261 1.642 4.261 3.908zm-1.865 0c0-1.407-1.11-2.37-2.396-2.37-1.287 0-2.396.963-2.396 2.37 0 1.391 1.109 2.368 2.396 2.368s2.396-.978 2.396-2.369z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.293 91.04c0 2.25-1.913 3.908-4.261 3.908s-4.261-1.658-4.261-3.909c0-2.264 1.913-3.908 4.261-3.908s4.261 1.642 4.261 3.908zm-1.865 0c0-1.407-1.109-2.37-2.396-2.37s-2.396.963-2.396 2.37c0 1.391 1.109 2.368 2.396 2.368s2.396-.978 2.396-2.369z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.104 87.367v7.017c0 2.886-1.85 4.065-4.037 4.065-2.06 0-3.298-1.267-3.766-2.303l1.624-.622c.29.636.998 1.387 2.14 1.387 1.4 0 2.268-.795 2.268-2.291v-.562h-.066c-.417.474-1.221.888-2.237.888-2.124 0-4.07-1.702-4.07-3.893 0-2.206 1.946-3.922 4.07-3.922 1.014 0 1.818.414 2.237.874h.066v-.637h1.771v-.001zm-1.64 3.686c0-1.376-.997-2.382-2.267-2.382a2.348 2.348 0 00-2.365 2.382c0 1.362 1.078 2.355 2.365 2.355 1.27 0 2.268-.993 2.268-2.355z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.025 83.254v11.454h-1.82V83.254h1.82z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.115 92.326l1.448.888c-.467.636-1.593 1.732-3.539 1.732-2.414 0-4.216-1.716-4.216-3.909 0-2.324 1.818-3.908 4.007-3.908 2.204 0 3.283 1.614 3.635 2.486l.194.444-5.679 2.164c.434.784 1.111 1.185 2.059 1.185.95 0 1.608-.43 2.091-1.082zm-4.457-1.407l3.796-1.45c-.208-.488-.837-.828-1.576-.828-.948 0-2.268.77-2.22 2.278z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69 90.022v-1.658h6.073c.06.289.09.63.09 1.001 0 1.244-.37 2.782-1.56 3.879-1.16 1.11-2.64 1.702-4.601 1.702-3.635 0-6.692-2.724-6.692-6.07 0-3.344 3.057-6.068 6.692-6.068 2.011 0 3.444.726 4.52 1.672l-1.272 1.17c-.772-.666-1.817-1.184-3.25-1.184-2.654 0-4.73 1.968-4.73 4.41 0 2.443 2.075 4.412 4.73 4.412 1.722 0 2.703-.636 3.33-1.215.51-.468.845-1.138.978-2.052l-4.308.001z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#search-engine-results_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 78.207,
    width: 247,
    height: 20.242,
    rx: 10.121
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 78.707,
    width: 246,
    height: 19.242,
    rx: 9.621,
    stroke: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    stroke: "#000",
    d: "M40 130.152h573.003"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 159.175,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 128,
    y: 140.773,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 128,
    y: 115.011,
    width: 270,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 172.056,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 184.937,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 195.058,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 223.581,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 236.462,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 249.343,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 259.464,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 287.987,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 300.868,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 313.75,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 323.87,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "search-engine-results_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 36,
    width: 441,
    height: 390
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 36.803,
    width: 441,
    height: 389.197,
    rx: 14,
    fill: "#525376"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 37.303,
    width: 440,
    height: 388.197,
    rx: 13.5,
    stroke: "#525376",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#search-engine-results_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#search-engine-results_svg__filter3_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 73.607,
    width: 573,
    height: 322.03,
    rx: 16,
    fill: "url(#search-engine-results_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 73.607,
    width: 573,
    height: 322.03,
    rx: 16,
    stroke: "#EEE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.577,
    cy: 88.859,
    rx: 3.577,
    ry: 3.291,
    fill: "#ED6A5D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.499,
    cy: 88.859,
    rx: 3.577,
    ry: 3.291,
    fill: "#F4BF4F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.425,
    cy: 88.859,
    rx: 3.577,
    ry: 3.291,
    fill: "#62C755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1 127.843c0 2.25-1.913 3.908-4.261 3.908s-4.262-1.658-4.262-3.908c0-2.267 1.914-3.909 4.262-3.909s4.261 1.642 4.261 3.909zm-1.865 0c0-1.407-1.109-2.369-2.396-2.369s-2.396.962-2.396 2.369c0 1.392 1.109 2.368 2.396 2.368s2.396-.978 2.396-2.368z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.293 127.843c0 2.25-1.913 3.908-4.261 3.908s-4.261-1.658-4.261-3.908c0-2.265 1.913-3.909 4.261-3.909s4.261 1.642 4.261 3.909zm-1.865 0c0-1.407-1.109-2.369-2.396-2.369s-2.396.962-2.396 2.369c0 1.392 1.109 2.368 2.396 2.368s2.396-.978 2.396-2.368z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.104 124.17v7.017c0 2.887-1.85 4.066-4.037 4.066-2.059 0-3.298-1.267-3.766-2.304l1.625-.622c.289.637.997 1.387 2.139 1.387 1.4 0 2.268-.794 2.268-2.291v-.562h-.066c-.417.474-1.221.888-2.237.888-2.124 0-4.07-1.702-4.07-3.892 0-2.207 1.946-3.923 4.07-3.923 1.014 0 1.818.414 2.237.874h.066v-.636h1.771v-.002zm-1.639 3.687c0-1.377-.998-2.383-2.268-2.383a2.348 2.348 0 00-2.365 2.383c0 1.362 1.078 2.354 2.365 2.354 1.27 0 2.268-.992 2.268-2.354z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.025 120.057v11.454h-1.82v-11.454h1.82z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.115 129.129l1.448.888c-.467.636-1.593 1.732-3.539 1.732-2.414 0-4.216-1.716-4.216-3.908 0-2.325 1.818-3.909 4.007-3.909 2.204 0 3.283 1.614 3.635 2.487l.194.444-5.679 2.164c.434.784 1.111 1.184 2.059 1.184.95 0 1.608-.43 2.091-1.082zm-4.457-1.406l3.796-1.451c-.208-.488-.837-.828-1.576-.828-.948 0-2.268.77-2.22 2.279z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.69 126.826v-1.659h6.073c.06.289.09.631.09 1.001 0 1.245-.369 2.783-1.561 3.879-1.158 1.11-2.639 1.702-4.6 1.702-3.635 0-6.692-2.724-6.692-6.069 0-3.344 3.057-6.069 6.692-6.069 2.011 0 3.444.726 4.52 1.673l-1.272 1.17c-.772-.666-1.817-1.185-3.25-1.185-2.655 0-4.731 1.969-4.731 4.411 0 2.443 2.076 4.411 4.731 4.411 1.722 0 2.702-.636 3.331-1.214.509-.469.844-1.138.976-2.053l-4.307.002z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#search-engine-results_svg__filter4_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 115.011,
    width: 247,
    height: 20.242,
    rx: 10.121
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 115.511,
    width: 246,
    height: 19.242,
    rx: 9.621,
    stroke: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    stroke: "#000",
    d: "M131 166.956h573.003"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 195.978,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 219,
    y: 177.577,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 219,
    y: 151.814,
    width: 270,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 208.86,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 221.741,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 231.862,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 260.384,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 273.266,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 286.147,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 296.268,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 324.791,
    width: 119,
    height: 6.441,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 337.672,
    width: 270,
    height: 8.281,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 350.553,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 219,
    y: 360.674,
    width: 270,
    height: 7.361,
    rx: 2,
    fill: "#C4C4C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "search-engine-results_svg__filter0_d",
    x: -63,
    y: -305,
    width: 614,
    height: 773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "search-engine-results_svg__filter1_di",
    x: 24.5,
    y: 22.303,
    width: 606,
    height: 355.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.696962 0 0 0 0 0.713378 0 0 0 0 0.770833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "search-engine-results_svg__filter2_d",
    x: 127,
    y: 58.207,
    width: 295,
    height: 68.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "search-engine-results_svg__filter3_di",
    x: 114.5,
    y: 59.107,
    width: 606,
    height: 355.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.696962 0 0 0 0 0.713378 0 0 0 0 0.770833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "search-engine-results_svg__filter4_d",
    x: 218,
    y: 95.011,
    width: 295,
    height: 68.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search-engine-results_svg__paint0_linear",
    x1: 242,
    y1: -291,
    x2: 242,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search-engine-results_svg__paint1_linear",
    x1: 327.5,
    y1: 36.803,
    x2: 327.5,
    y2: 358.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search-engine-results_svg__paint2_linear",
    x1: 417.5,
    y1: 73.607,
    x2: 417.5,
    y2: 395.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "search-engine-results_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-780 -4409)",
    d: "M0 0h1440v10270H0z"
  })))));
}

export default __webpack_public_path__ + "static/search-engine-results.5b25cbdb.svg";
export { SvgSearchEngineResults as ReactComponent };